module.exports = __webpack_public_path__ + "static/img/Tom-Hawkins.779ee77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Hawkins.jpg
// module id = NgoF
// module chunks = 0